import * as React from 'react';
import clsx from "clsx";
import {
  AppBar,
  CssBaseline,
  makeStyles,
  Toolbar,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import { drawerWidth } from "../../store/constant";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Breadcrumb from "./../../ui-component/extended/Breadcrumb";
import navigation from "./../../menu-items/main-menu-items";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useDispatch } from "react-redux";
import {useSelector} from "../../store/reducer";
import LogoSection from './LogoSection';
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  appBarWidth: {
    transition: theme.transitions.create("width"),
    
  },
  content: {
    ...theme.typography.mainContent,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up("md")]: {
      marginLeft: -(drawerWidth - 20),
      width: `calc(100% - ${drawerWidth}px)`,
      marginTop : "70px"
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: "10px",
      width: `calc(100% - ${drawerWidth}px)`,
      padding: "0px",
      marginTop : "70px"
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "10px",
      width: `calc(100% - ${drawerWidth}px)`,
      padding: "0px",
      marginRight: "10px",
      marginTop : "70px"
    }
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0,
    padding : 0,
    [theme.breakpoints.down("md")]: {
      marginLeft: "10px",
      marginTop : "70px"
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "10px"
    }
  }
}));
interface MainLayoutProps {
  children: React.ReactNode;
  showBreadcrumb?: boolean
}
const MainLayout = (props: MainLayoutProps) => {
  const { children, showBreadcrumb = true } = props;
  const classes = useStyles();
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  // Handle left drawer
  const leftDrawerOpened = useSelector(state => state.customization.opened);
  const dispatch = useDispatch();
  const handleLeftDrawerToggle = () => {
    dispatch({ type: "SET_MENU", opened: !leftDrawerOpened });
  };
  React.useEffect(() => {
    const openLeftDrawerState = (val:boolean) => {
      dispatch({ type: "SET_MENU", opened: false });
    };
    openLeftDrawerState(matchUpMd);
  }, [dispatch, matchUpMd]);
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
      >
        <Toolbar>
          <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
        </Toolbar>
      </AppBar>
      <Sidebar
        drawerOpen={leftDrawerOpened}
        drawerToggle={handleLeftDrawerToggle}
      />
      <main
        className={clsx([
          classes.content,
          {
            [classes.contentShift]: leftDrawerOpened
          }
        ])}
      >
        {showBreadcrumb && (
          <Breadcrumb
            separator={KeyboardArrowRightIcon}
            navigation={navigation}
            icon
            title
            rightAlign
          />
        )}
        <div>{children}</div>
      </main>
      <div className='footer-logo'>
             <LogoSection></LogoSection>
      </div>
    </div>
  );
};
export default MainLayout;
